

import { AfterViewInit, Inject, Component, EventEmitter, ApplicationRef, OnDestroy, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';
import { BehaviorSubject, Observable, throwError, filter, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

import { TabsComponent } from 'src/app/tabs/tabs.component';
import { SearchServiceService } from '../search-service.service';
import { UserserviceService } from 'src/app/services/userservice/userservice.service';
import { LocalStorageService } from 'src/app/services/localstorage-service/localstorage-service';
import { StandardUIService } from 'src/app/services/standardui-service/standardui-service';
// import { ApiService } from 'src/app/SmartReporter/sm-Services/api.service';
// import { BreadcrumbService } from 'src/app/SmartReporter/sm-Services/breadcrumb.service';
// import { TableauReportsService } from 'src/app/SmartReporter/sm-Services/tableau-reports.service';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { httpOptions } from '../../util/httpoptions';
import { catchError, retry } from 'rxjs/operators';
import { ApiserviceService } from 'src/app/Service/apiservice.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FaqService } from 'src/app/services/faq-services/faq.service';
import { UtilityServiceService } from 'src/app/services/utility-services/utility-service.service';
import { isString } from '@ng-bootstrap/ng-bootstrap/util/util';
import { BreadcrumbService } from 'src/app/services/sm-Services/breadcrumb.service';
import { TableauReportsService } from 'src/app/services/sm-Services/tableau-reports.service';
import { ApiService } from 'src/app/services/sm-Services/api.service';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';


declare let onEventEstablishedInbound: Function;
// interface ImageButton {
//   src: string;
//   alt: string;
//   selected: boolean;
//   text: string;
//   type: string;
//   id: string;
//   height: string;
//   entityName: string;
//   department: string;
// }
@Component({
  selector: 'app-layout',

  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None,


})
// export class NgbdDropdownBasic {}
export class LayoutComponent {
  showBox = false;
  // globalsearchletter: any;
  isNavOpen = false;
  isSBoxOpen = false;
  selectedItem = 'home';
  userInfo:any;
  userRole: any;
  reportId: any;

  activeIndex: number=0;
  toggleQsearch(menulabel): void {
    this.isNavOpen = !this.isNavOpen;
  }
  toggleRecent(): void {
    this.isSBoxOpen = !this.isSBoxOpen;
  }
  selectedOption = 'Contact Search';
  imageButtons=  [
    { src: '../../assets/images/data-analytics.svg', alt: '311 Home', text: '311 Home', selected: true, type: "home", id: "home", height: "24px" },
    { src: '../../assets/images/NewSRactive.svg', alt: 'New Service Request', text: 'New Service Request (SR)', selected: false, type: "configuredNewSR", id: "configuredNewSR", height: "24px" },
    { src: '../../assets/images/NewContactActive.svg', alt: 'New Contact', text: 'New Contact', selected: false, type: "object", id: "newcontact", entityName:'Contact',department:'Contact',height: "24px" },
    { src: '../../assets/images/NewAnswerActive.svg', alt: 'New Answer', text: 'New Answer', selected: false, type: "object", id: "newanswer", entityName:'Answer',department:'Answer', height: "24px" },
    { src: '../../assets/images/files-fill.svg', alt: "All Service Requests", text: "311 SR Queue", selected: false, type: "query", id: "1", height: "14px" }
  ];
  ImageSR: any;
  buttonid = 1;
  buttonid1 = 1;
  buttontext: any;
  backendUrl = environment.apiURL;
  navigationByRole: any;
  leftTopNavigations=[];
  leftNavigations=[];

  redirecttohome()
  {
    $("[data-obj-id='home']").parent().trigger('click');
  }

  private handleError(errorObj: HttpErrorResponse | any) {
    const _self = this;
    let errorMessage: string;
    let body: any;
    if (errorObj instanceof HttpErrorResponse) {
      if (errorObj.ok === false && errorObj.status === 0) {
        errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime.';
      } else {
        body = errorObj.error || '';
        errorMessage = body.message ? body.message : body.error.message;
      }
    }
    return throwError(errorMessage);
  }
  tabs: any;
  faqForm: FormGroup;
  getpopular() {

    // localStorage.removeItem("addtab");
    $("#popular").prop('checked', true);
    localStorage.setItem("filter", "Popular");
    localStorage.removeItem("keyword");
    this.oncomponentSelection({
      id: 'faq',
      name: 'FAQ',
      type: 'faq'
    });
    this.tabs = [] || JSON.parse(localStorage.getItem('addtab'));
    this.faqForm.patchValue({
      name: ""
    });
  }
  onkey() {

    localStorage.setItem("filter", "Recent");
    localStorage.removeItem("keyword");
    this.tabs = [] || JSON.parse(localStorage.getItem('addtab'));
    this.oncomponentSelection({
      id: 'faq',
      name: 'FAQ',
      type: 'faq'
    });
    this.faqForm.patchValue({
      name: ""
    });
    $("#all").prop('checked', false);
    $("#atoz").prop('checked', false);
    $("#popular").prop('checked', false);
  }
  getaz() {
    // localStorage.removeItem("addtab");
    this.faqService.getAtoZCount().subscribe(data => {
      this.utilityService.setAtoZCount(data);
    });
    localStorage.setItem("filter", "A-Z");
    localStorage.removeItem("keyword");
    this.tabs = [] || localStorage.getItem('addtab');
    this.oncomponentSelection({
      id: 'faq',
      name: 'FAQ',
      type: 'faq'
    });
    this.faqForm.patchValue({
      name: ""
    });
  }
  get name() {
    return this.faqForm.controls['name'];
  }
  getall() {
    // localStorage.removeItem("addtab");
    localStorage.setItem("filter", "All");
    localStorage.removeItem("keyword");
    this.tabs = [] || JSON.parse(localStorage.getItem('addtab'));
    this.oncomponentSelection({
      id: 'faq',
      name: 'FAQ',
      type: 'faq'
    });
    this.faqForm.patchValue({
      name: ""
    });
  }
  isActive(index: number): boolean {
    return index === this.activeIndex;
  }

  selectButton(clickedButton: any,index:any) {
    if(clickedButton.type=='home'){
      this.redirecttohome();
      return false;
    }
    this.activeIndex = index;
    // $(".btn-dashbord").removeClass("selected");
    // $(".sidenav-inner ul").find("div").removeClass("link-active");
    //let linkid = $(".custom-tabs li.active").find("a").attr('data-obj-id');
    //alert(clickedButton.label);
    clickedButton.label=clickedButton.reportid? clickedButton.reportid:clickedButton.label
    setTimeout(()=>{



      // $(document).ready(function() {
      //   var status = $(".sidenav-link  span");
      //   status.each(function(index) {
      //       if ($(this).text() == "Risk Management SR Queue") {
      //         $(this).css("font-size", "10px");
      //       } else {
      //         $(this).css("font-size", "11px");
      //       }
      //     });
      //   });


      $('[data-link-id]').removeClass('link-active');
      $('[data-link-id="'+clickedButton.label+'"]').addClass('link-active');
    },200)
    // this.imageButtons.forEach((button, index) => {
    //   if (button === clickedButton) {
    //     button.selected = true;
    //     $("#mainListTab" + index).addClass("selected");
    //     $(".sidenav-inner ul li").eq(index).find("div").addClass("link-active");
    //   }
    // });
    this.buttontext = clickedButton.reportname;


    if (clickedButton.type == "configuredNewSR") {

      // clickedButton.id = "configuredNewSR" + this.buttonid
      this.getIncidentref({ id: "configuredNewSR" + this.buttonid, name: this.buttontext, type: clickedButton.type, src: clickedButton.imageicon })
      this.buttonid++;
      return;
      // setTimeout(()=>{
      //   clickedButton.id = "configuredNewSR" + this.buttonid
      //   this.buttontext = this.tabid

      // })
      // clickedButton.id = "configuredNewSR" + this.buttonid
      // this.buttontext = this.tabid
      // this.buttontext=this.getIncidentref();
      // this.tabsComponent.openTab(this.buttontext, this.componentSelectionTemplate, { id: clickedButton.id, name: this.buttontext, type: clickedButton.type }, true, [...this.breadcrumbservice.breadcrumb]);
    }
    clickedButton.department = clickedButton.entityname
    clickedButton.id = clickedButton.label
    console.log(clickedButton,"clickedButtonclickedButton")
    // return false;
    const filteredData = {
      actiontype: clickedButton.actiontype,
      department: clickedButton.department,
      entityName: clickedButton.entityname,
      id: clickedButton.id,
      name: clickedButton.reportname,
      src: clickedButton.activeimageicon,
      type: clickedButton.type
    };
    console.log("filteredDatafilteredData",filteredData);
  //   {
  //     "actiontype": "new",
  //     "department": "Answer",
  //     "entityName": "Answer",
  //     "id": "newanswer",
  //     "name": "New Answer",
  //     "src": "https://fortwayne-portal.thesmartcity311.com/assets/images/NewAnswerActive.svg",
  //     "type": "object"
  // }
  // if(filteredData.entityName=='Answer' && filteredData.department=='Answer')
  //   {
  //     filteredData.type='answer';
  //   }
    //$('[data-link-id="'+filteredData.id+'"]').addClass('link-active');
    // return false;
    this.tabsComponent.openTab(this.buttontext, this.componentSelectionTemplate, filteredData , true, [...this.breadcrumbservice.breadcrumb]);

  }


  globalsearch(name: any) {

    console.log(name)
    this.tabsComponent.openTab(this.buttontext, this.componentSelectionTemplate, { id: 2, name: name, type: 'query', src: '../../assets/images/files.svg' }, true, [...this.breadcrumbservice.breadcrumb]);

  }
  sideMenu: any = ["Smart Reporter", "My Categories", "My Favourites", "Recently Viewed", "View Later"];
  @Output() componentSelection = new EventEmitter<any>();
  @ViewChild('MyReports') MyReportsTemplate: any;
  isBoxOpen = false;

  toggleBox(open: boolean) {
    this.isBoxOpen = open;
  }


  globalsearchform: FormGroup;


  displayName: any;
  public abstractor: boolean = false;
  // lightTheme = 'minimal';
  lightTheme = 'light';
  isLoginUser:boolean= false;
  constructor(private formBuilder: FormBuilder, private httpClient: HttpClient,
    public breadcrumbservice: BreadcrumbService,
    public Tableauservice: TableauReportsService,
    private authService: MsalService,
    // private apiService: ApiService,
    private agentscriptservice:AgentscriptService_updated,
    private _standardUiService: StandardUIService, private _appRef: ApplicationRef, private userService: UserserviceService, private localStorageService: LocalStorageService, private apiservices: ApiserviceService, private faqService: FaqService, private utilityService: UtilityServiceService) {

    this.userService.getUser().subscribe((data) => {
      console.log(data.roles[0].authority);
      this._standardUiService.setUserDetails(data);
      if(data.roles[0].authority == 'Department' || data.roles[0].authority == 'Parking Control'){
          $("#IWSConnectorToolbar").remove();
      }
      console.log(data.location.id);
      localStorage.setItem("role",data.roles[0].authority.toString())
      localStorage.setItem("locationid",data.location.id)
      localStorage.setItem("locationname",data.location.locationname)
      this.isLoginUser= true;
      console.log(localStorage.getItem("role"));
      console.log(localStorage.getItem("locationid"));
      var roleid=data.roles[0].id
      this.userService.user_roleid=data.roles[0].id
      this.userService.getAllNavigationSetByrole(roleid).subscribe((data) => {

        this.navigationByRole = data;
        console.log("getAllNavigationSetByrole",this.navigationByRole);
         this.leftTopNavigations = this.navigationByRole.filter(navigation => navigation.position === 'lefttop');
         this.leftNavigations = this.navigationByRole.filter(navigation => navigation.position === 'left');
        console.log("leftTopNavigationsleftTopNavigations",this.leftTopNavigations);

        this.userRole=localStorage.getItem("role")                        
        if(this.userRole == 'Department' || (this.userRole == localStorage.getItem("locationname"))){
          let reportId;
          this.navigationByRole.forEach(navigation => {
            console.log(navigation);
            reportId = navigation.reportid
            if(reportId != null){
              console.log("reportid",reportId.toString())
              if(navigation.position == 'lefttop'){
                var reportString = reportId.toString()
                setTimeout(() => {
                  console.log(reportString);
                  $('[data-link-id="'+reportString+'"]').trigger('click');
                },500)
              }              
            }
          })

        }else{
         // alert("nodata")
        }

  })

      localStorage.setItem('loginattempt', '1');
      this.localStorageService.set('currentUser', data);
      this.userInfo = data;
      this.displayName = {
        "fullname": data.firstname + " " + data.lastname,
        "email": data.email,
        "role": (data.roles.length > 0) ? data.roles[0].name : '',
        "agentrole": (data.roles.length > 0) ? data.roles[0].authority : '',
        "departmentname":  data.location.locationname
      };
      console.log('sss', this.displayName);
      for (let i = 0; i < data.roles.length; i++) {
        if (data.roles[i].name == "Abstractor") {
          this.abstractor = false;

          break;
        }
      }
    });

  }

  tabopen: boolean = true;

  getFormattedDate(): string {
    const today = new Date();
    const day = ('0' + today.getDate()).slice(-2);
    const month = ('0' + (today.getMonth() + 1)).slice(-2); 
    const year = today.getFullYear().toString().slice(-2); 
  
    return `${year}${month}${day}`;
  }

  todaysdate:any
  ngAfterViewInit() {
    this.todaysdate=this.getFormattedDate()
    setTimeout(() => {

      this.tabopen = true;
      // this.initialized = true;

      // this.layoutService.init();
      // this.layoutService.update();
      // this.layoutService.setAutoUpdate(true);


      // this.navbar.getAbstractor().subscribe(data=>{
      // if(!data){

      //  this.tabsComponent.openTab(`allSR`, this.componentSelectionTemplate, { id: 'allSR', name: 'Incidents', type: 'query' }, true, [...this.breadcrumbservice.breadcrumb]);
      this.tabsComponent.openTab(`311 Home`, this.componentSelectionTemplate, { id: 'home', name: '311 Home', type: 'home', src: '../../assets/images/data-analytics.svg' }, true, [...this.breadcrumbservice.breadcrumb]);

      $("#searchcomp").removeClass("link-active");

      console.log(JSON.parse(localStorage.getItem('servicepayload')))
      // this.testdata=[]
      if(this._standardUiService.fetchfromlocalStorage('servicepayload')!=null)
        {
          var localstoragepayload:any
          localstoragepayload=JSON.parse(this._standardUiService.fetchfromlocalStorage('servicepayload'))
          localstoragepayload.forEach((item: any, index: number) =>
                {
                  // alert()
                  
                  setTimeout(() => {
                    console.log(item)
                  console.log(this.componentSelection)
                  item.id=item.name
                  item['localstorage']=true
                  console.log(this.componentSelectionTemplate)
                  console.log(item.name,this.componentSelectionTemplate,item,true, [...this.breadcrumbservice.breadcrumb])
                  this.tabsComponent.openTab(item.name,this.componentSelectionTemplate,item,true, [...this.breadcrumbservice.breadcrumb])
                    
                  }
                  // , 5000 * index
                );
                })
        }
      if(this._standardUiService.fetchfromlocalStorage('addressdetailscomponent')!=null)
      {
        var localstoragedata=JSON.parse(this._standardUiService.fetchfromlocalStorage('tabdata'))

        var arraytest:any=[]

        // alert('412')
        var localstoragepayload:any
        localstoragepayload=JSON.parse(this._standardUiService.fetchfromlocalStorage('addressdetailscomponent'))
        console.log(JSON.parse(this._standardUiService.fetchfromlocalStorage('addressdetailscomponent')))
        localstoragepayload.forEach((item: any, index: number) =>
              {
                // alert()
                
                setTimeout(() => {
                  console.log(item)
                console.log(this.componentSelection)
                item.id=item.name
                item['localstorage']=true
                console.log(this.componentSelectionTemplate)
                console.log(item.data)

                console.log(item.name,this.componentSelectionTemplate,{redirectTo:'gridView',viewname:'addressView','serviceDetails':item},true, [...this.breadcrumbservice.breadcrumb])
                var servicedetails=item.data
                servicedetails['src']="../../assets/images/NewSRactive.svg"
                servicedetails['id']="configuredNewSR"+item.name
                servicedetails['name']="NewSR"
                servicedetails['type']="configuredNewSR"
                servicedetails['tabid']=item.name
                // servicedetails['tabdata']=item.tabdata?item.tabdata:'0'
                  console.log(item.tabdata)

                  console.log(item.data)
                  console.log(servicedetails)
                  console.log(item.name,this.componentSelectionTemplate,{redirectTo:'gridView',viewname:'addressView','serviceDetails':servicedetails},true, [...this.breadcrumbservice.breadcrumb])
                // this.tabsComponent.openTab(item.data)
                // setTimeout(() => {
                //console.log(localstoragedata[0])
                var localstoragealldatarray=localstoragedata[0]?.find(data => data.refno == item.name);
                console.log(localstoragealldatarray)
                // localstoragealldatarray.refno='240000'
                console.log(this.agentscriptservice.AlldataArray)
                if(localstoragealldatarray)
                {
                  if(localstoragealldatarray.refno?.toString().split('-')[0]==this.todaysdate)
                  {
                    arraytest.push(localstoragealldatarray)
                  console.log(localstoragealldatarray)
                this.agentscriptservice.AlldataArray.push(localstoragealldatarray)
                this.tabsComponent.openTab(item.name,this.componentSelectionTemplate,servicedetails,true, [...this.breadcrumbservice.breadcrumb])

                  }
                  else
                  {
                    this._standardUiService.clearlocalStorage('addressdetailscomponent',localstoragealldatarray.refno)
                    this._standardUiService.clearlocalStorage('servicepayload',localstoragealldatarray.refno)
                    this._standardUiService.clearlocalStorage('tabdata',localstoragealldatarray.refno)
                  }
                  
                }
                // this.tabsComponent.openTab(item.name,this.componentSelectionTemplate,servicedetails,true, [...this.breadcrumbservice.breadcrumb])

                console.log(this.agentscriptservice.AlldataArray)

                // }, 500);
                
                // localstoragedata.forEach((item:any, index: number)=>
                // {
                //   console.log(item[index].refno)
                //   // this.agentscriptservice.updateOrInsertArray()
                //   // setTimeout(() => {
                //   //   this.agentscriptservice.updateOrInsertArray
                //   // }, 250);
                  
                // })
                  
                }
                // , 5000 * index
              );
              // this.agentscriptservice.AlldataArray=arraytest
              }
            )
      }


      // $(".sidenav-link").eq(1).addClass("link-active");

    }, 500);

    $(document).on('click', '.haslist', function (e) {
      $(this).toggleClass('active');
      // $(this).find('i.right').toggleClass('active');
      $(this).next().slideToggle();


      //$(this).attr('aria-expanded',true);

      // if ($(this).hasClass('active')) {
      //   $(this).next().slideUp(250);
      //   $(this).removeClass('active');
      //   //$(this).attr('aria-expanded',false);
      //   //$(this).removeAttr('aria-current');
      //   return false;
      // }
      // $('.haslist').removeClass('active');
      // $('.haslist').removeAttr('aria-current');
      // // $('.nl-container').slideUp(250);
      // $(this).addClass('active');
      // //$(this).attr('aria-expanded',true);
      // //$(this).attr('aria-current', 'page');
      // $(this).next().slideDown(250);
    });
    $(document).on('click', ' .switcher-btn, .close-switcher', function () {

      $('.switcher-wrapper').toggleClass('switcher-toggled'), 500;
    });
    const self = this;
    $(document).on('click', '.custom-tabs li', function () {

        $('[data-link-id]').removeClass('link-active');

        let v:any = $(this).find('a').attr('data-obj-id');

        if(isNaN(v)){
          v= v.replace(/\d+$/, '');
        }

        $('[data-link-id="'+v+'"]').addClass('link-active');

    })
    $(document).on('click', ' div.sidenav-link', function (title: any, index: number, displayName: String, link: boolean) {
      $('[data-link-id]').removeClass('link-active');
      //setTimeout(()=>{
        $('[data-link-id="'+$(this).attr('data-link-id')+'"]').addClass('link-active');
        //$(this).addClass("link-active");
      //},500)
      //$(".tree").find("li").removeClass("link-active");
      // $(".tree").find(".sidenav-link").removeClass("link-active");
      // $(this).addClass("link-active");

      // if ($(this).attr("data-link-id") == "sm-smartreporter") {
      //   //$(this).removeClass('link-active');
      //   $(".tree").find(".link-active").removeClass("link-active");
      //   $("ul.smtreporter li").eq(0).find("div.sidenav-link").addClass("link-active");
      // } else {
      //   let displayName = $(this).text();
      //   let _index = self.sideMenu.indexOf(displayName);
      //   if (_index > -1) {
      //     $(".tree").find(".link-active").removeClass("link-active");
      //     $("ul.smtreporter li").eq(_index - 1).find("div.sidenav-link").addClass("link-active");
      //   }
      // }
      // let _index =this.sideMenu.indexOf(displayName);
      // $("ul.smtreporter li").eq(_index).addClass("link-active");
      // $(this).parent().addClass('link-active');
      // if((this).parent().addClass('link-active')==false){
      //   $("ul.smtreporter li").find("div.mycat2").removeClass("link-active");
      // }


      // $("ul.smtreporter li").find("div.mycat2").addClass("link-active");
      // $("ul.smtreporter li").eq(_index).find("div").addClass("link-active");

    });
    // let _index =this.sideMenu.indexOf(displayName);
    // console.log(_index,"my reports")
    // $(".haslist").removeClass("link-active");
    // $("ul.smtreporter").find("div").removeClass("link-active");
    // $("ul.smtreporter li").find("div").removeClass("link-active");
    //  $("ul.smtreporter li").eq(_index).find("div").addClass("link-active");
    $(document).on('click', '.tab-close,.custom-tabs li a', function () {
      // $(".tree").find(".sidenav-link").removeClass("link-active");
      // let activeTab = $("ul.custom-tabs li.active").find("a").text();
      // if (activeTab.trim() == "Home") {
      //   $(".sidenav-link").eq(0).addClass("link-active");
      // }
      // if (activeTab.trim() == "Search") {
      //   $(".sidenav-link").eq(1).addClass("link-active");
      // }
      // if (activeTab.trim() == "NewSR") {
      //   $(".sidenav-link").eq(1).addClass("link-active");
      //   $("#").eq(1).removeClass("link-active");
      // }
      // if (activeTab.trim() == "Smart Reporter") {
      //   $("ul.smtreporter li").eq(0).find("div").addClass("link-active");
      // }
      // $('[data-link-id="'+$(this).parent().data('obj-id')+'"]').parent().removeClass('link-active');
      // setTimeout(()=>{
      //   let objid:any = $('.custom-tabs').find('li.active a').data('obj-id');
      //  // $('[data-link-id="'+objid+'"]').parent().addClass('link-active');
      //   //$('[data-link-id="'+objid+'"]').parents('sidenav-menu').trigger('click');
      // },100)
    });
    // $(document).on('click','.custom-tabs li a',function(){
    //   $(".tree").find("span.sidenav-link").parent("div").removeClass("link-active");
    //   let activeTab=$("ul.custom-tabs li.active").find("a").text();
    //   if(activeTab.trim()=="Home"){
    //     $("span.sidenav-link").eq(0).parent("div").addClass("link-active");
    //   }
    //   if(activeTab.trim()=="Search"){
    //     $("span.sidenav-link").eq(1).parent("div").addClass("link-active");
    //   }
    //   if(activeTab.trim()=="Smart Reporter"){
    //     $("ul.smtreporter li").eq(0).find("div").addClass("link-active");
    //   }
    //   //let objid:any = $(this).data('obj-id');
    //   //$(' .sidenav-link').parent().removeClass('link-active');
    //  // $('[data-link-id="'+objid+'"]').parent().addClass('link-active');
    //   //$('.sidenav-toggle').eq(0).parent().trigger('click');
    //   //$('.sidenav-toggle').eq(0).trigger('click');
    // });

  }

  title = 'AgentPortal';
  // @Output() componentSelection = new EventEmitter<any>();
  @ViewChild('sidenav') sidenav: MatSidenav | undefined;
  @ViewChild(TabsComponent) tabsComponent;
  @ViewChild('componentSelectionTemplate') componentSelectionTemplate;
  // abstractor:boolean;

  isExpanded = false;

  showSubmenu: boolean = false;
  showMenu4: boolean = false;
  showSub3Menu: boolean = false;
  showSub4Menu: boolean = false;
  showSub5Menu: boolean = false;
  showSub6Menu: boolean = false;
  showSub7Menu: boolean = false;
  showSub8Menu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  showSubSub2Menu: boolean = false;
  showSubSub3Menu: boolean = false;
  showSubSubSubMenu: boolean = false;
  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  addtobreadcrumb(title: String, index: number, displayName: String, link: boolean) {
    console.log(displayName)
    setTimeout(() => {
      let styleindex1 = 0;
      if (displayName == "Home") {
        $("span.sidenav-link").eq(0).parent("div").addClass("link-active");
        $("span.sidenav-link").eq(1).parent("div").removeClass("link-active");
      }
      else if (displayName == "Search") {
        $("span.sidenav-link").eq(0).parent("div").removeClass("link-active");
        $("span.sidenav-link").eq(1).parent("div").addClass("link-active");
      }
      else if (displayName == "NewSR") {
        $("span.sidenav-link").eq(1).parent("div").addClass("link-active");
        styleindex1 = 1;
      }
      else if (displayName == "TrackSR") {
        $("span.sidenav-link").eq(1).parent("div").addClass("link-active");
        styleindex1 = 2;
      }
      else if (displayName == "Incidents") {
        $("span.sidenav-link").eq(1).parent("div").addClass("link-active");
        styleindex1 = 3;
      }
      $(".btn-dashbord").removeClass("selected");
      $("#mainListTab" + styleindex1).addClass("selected");
    }, 100);
    let _index = this.sideMenu.indexOf(displayName);
    console.log(_index)
    // console.log(this.sideMenu,'index')
    if (_index > -1) {
      $(".haslist").find("div").removeClass("link-active");
      $("ul.smtreporter").find("div").removeClass("link-active");
      $("ul.smtreporter li").eq(_index).find("div").addClass("link-active");
    }
    // $("ul.smtreporter li").find("div").removeClass("link-active");
    // $("ul.smtreporter li").eq(0).find("div").addClass("link-active");
    // $("ul.smtreporter li.mycat1").eq(_index).find("div.mycat2").addClass("link-active");
    //  $("ul.smtreporter li").eq(_index).find("div").addClass("link-active");
    // // console.log(title,index,pre_title)
    this.breadcrumbservice.add(title, index, displayName, link);
    //$(".ul.smtreporter li").find('div').removeClass("link-active");

  }


  stylingtabs(stylingtab) {

    console.log("in stylings tab")
    console.log(stylingtab)
    if (stylingtab == 'close') {
      console.log("in close")
      $("#testID").removeClass("active");
      $('#parentsmartreporter').removeClass("active");
      $('#childsmartreporter').css("display", "none");
    }
    else if (stylingtab == 'open') {
      console.log("in close")
      $("#testID").addClass("active");
      $('#parentsmartreporter').addClass("active");
      $('#childsmartreporter').css("display", "block");
    }
    else {

      let styleindex1 = stylingtab;
      // if (isNaN(stylingtab)) {
      //   this.imageButtons.forEach((item, index) => {
      //     if (item.type == stylingtab) {
      //       styleindex1 = index;
      //     }
      //   });
      // }
      setTimeout(() => {
        //$(".haslist").find("div").removeClass("link-active");
        //$(".sidenav-inner ul").find("div").removeClass("link-active");
        $(".sidenav-inner ul li").eq(styleindex1).find("div").addClass("link-active");
        $("#testID").removeClass("link-active");
        $(".btn-dashbord").removeClass("selected");
        $("#mainListTab" + styleindex1).addClass("selected");
      })
    }
  }


  oncomponentSelection(componentData) {
  //   {
  //     "id": "newanswer",
  //     "name": "New Answer",
  //     "type": "object",
  //     "entityName": "Answer",
  //     "department": "Answer",
  //     "src": "https://fortwayne-portal.thesmartcity311.com/assets/images/NewAnswerActive.svg",
  //     "actiontype": "new"
  // }
  // if(componentData.entityName=='Answer' && componentData.department=='Answer')
  //   {
  //     componentData.type='answer';
  //     componentData.id='answer';
  //   }
    console.log(componentData)

     localStorage.setItem("filter", "All");

     $(".layout-wrapper").addClass('nl-collapse');


    // if (componentData.type == 'query') {
    //   $('#dropdown_click_close').trigger('click')
    //   const selectedOption = this.globalsearchform?.get('selectedOption')?.value;

    //   if (selectedOption === 'contactSearchForm') {
    //     componentData.advanceSearch = this.globalsearchform.get('contactSearchForm').value
    //     console.log(this.globalsearchform.get('contactSearchForm').value)
    //     componentData.id = 3
    //     componentData.name = 'Contact Search'
    //     componentData.src = '../../assets/images/files.svg'

    //   } else if (selectedOption === 'answerSearchForm') {
    //     componentData.advanceSearch = this.globalsearchform.get('answerSearchForm').value
    //     console.log(this.globalsearchform.get('answerSearchForm').value)
    //     componentData.id = 4
    //     componentData.name = 'Answer Search'
    //     componentData.src = '../../assets/images/files.svg'
    //   } else {
    //     componentData.advanceSearch = this.globalsearchform.get('incidentSearchForm').value
    //     console.log(this.globalsearchform.get('incidentSearchForm').value)
    //     componentData.id = 2
    //     componentData.name = 'Service Request Search'
    //     componentData.src = '../../assets/images/files.svg'
    //   }

    // }

    // if(componentData.type=='query' && componentData.id!=="1")
    // {
    //   console.log(componentData.type)
    //   $("mainListTab1").removeClass("selected")

    //   for (let i = 0; i <= 3; i++) {
    //     let id = `mainListTab${i}`;
    //     if ($(`#${id}`).attr('id').includes('mainListTab')) {
    //         $(`#${id}`).removeClass('selected');
    //     }
    // }

    // $("div").removeClass("link-active")
    // }
    console.log(componentData)
    if(componentData.id=='home'){
      this.redirecttohome();
      return false;
    }
    let styleindex;

    if (componentData.type == 'cat') {
      console.log("in cat")
      // this.CategoryTable();
      styleindex = 0;
    }
    // else if (componentData.type == 'fav') {
    //   $(".smartreporter-tabs").addClass("gg");
    //   this.MyFavoritesOpen();
    //   styleindex = 1;
    // }

    // else if (componentData.type == 'rcv') {
    //   this.RecentlyViewdOpen();
    //   styleindex = 2;
    // }

    // else if (componentData.type == 'wtl') {
    //   this.WatchLaterOpen();
    //   styleindex = 3;
    // }
    else if (componentData.title == 'home') {
      console.log("In layout Home")
      // alert('Home');
      // return false;
      $("li").removeClass("link-active");
      $("div.sidenav-link").removeClass("link-active");
      $("div.sidenav-link").eq(0).addClass("link-active");

      // this.tabsComponent.openTab(`${componentData.name}`, this.componentSelectionTemplate, componentData, true,[...this.breadcrumbservice.breadcrumb]);
    }

    // else if (componentData.title == 'Smart Reporter') {

    //   // $("#testID").switchClass("link-active","tt")


    //   if (componentData.displayName == 'My Categories') {
    //     this.CategoryTable();
    //     // this.apiService.cat_table = true;
    //     // this.apiService.fav = false;
    //     // this.apiService.wtl = false;
    //     // this.apiService.rcv = false;
    //     styleindex = 0;
    //   }
    //   else if (componentData.displayName == 'My Favourites') {
    //     this.MyFavoritesOpen();
    //     // this.apiService.cat_table = false;
    //     // this.apiService.fav = true;
    //     // this.apiService.wtl = false;
    //     // this.apiService.rcv = false;
    //     styleindex = 1;
    //   }
    //   else if (componentData.displayName == 'Recently Viewed') {
    //     this.RecentlyViewdOpen();
    //     // this.apiService.cat_table = false;
    //     // this.apiService.fav = false;
    //     // this.apiService.wtl = false;
    //     // this.apiService.rcv = true;
    //     styleindex = 2;
    //   }
    //   else if (componentData.displayName == 'View Later') {
    //     this.WatchLaterOpen();
    //     // this.apiService.cat_table = false;
    //     // this.apiService.fav = false;
    //     // this.apiService.wtl = true;
    //     // this.apiService.rcv = false;
    //     styleindex = 3;
    //   }
    //   console.log("Smart Reporter from layout")
    //   // $("span.sidenav-link").parent("div").removeClass("link-active");
    //   // $("span.sidenav-link").eq(4).parent("div").addClass("link-active");

    //   $(".haslist").find("div").removeClass("link-active");
    //   $("ul.smtreporter").find("div").removeClass("link-active");
    //   $("ul.smtreporter li").eq(styleindex).find("div").addClass("link-active");
    //   $("#testID").toggleClass("link-active");

    //   // $("li").replace("tt").removeClass("link-active");
    //   // let displayName=$(this).text();
    //   //     let _index =this.sideMenu.indexOf(displayName);
    //   //     if(_index>-1){
    //   //       $(".tree").find(".link-active").removeClass("link-active");
    //   //       $("ul.smtreporter li").eq(_index-1).find("div").addClass("link-active");
    //   //     }
    // }
    else {
      if (componentData.type.includes("configuredNewSR")) {

        componentData.id = "configuredNewSR" + this.buttonid
        this.getIncidentref(componentData)
        this.buttonid++;
        this.apiservices.gensysdata = componentData;
        console.log(componentData)
        console.log(this.apiservices.gensysdata)
        return;
        // componentData.name = this.tabid
        // // componentData.name=this.getIncidentref();
        componentData.id = "configuredNewSR" + this.buttonid
        // this.buttonid++;
      }

      else if (componentData.type.includes("alertincident") && componentData.entityName!='opencreatedalert') {

            componentData.id = "alertincident" + this.buttonid1
            this.getIncidentref(componentData)
            this.buttonid1++;
            console.log(componentData)
            return;



        // componentData.name = this.tabid
        // // componentData.name=this.getIncidentref();
        // componentData.id = "configuredNewSR" + this.buttonid1
        // // this.buttonid1++;
      }
      // console.log("increatenewsr")
      console.log("openTab" + componentData.name);
      this.tabsComponent.openTab(`${componentData.name}`, this.componentSelectionTemplate, componentData, true, [...this.breadcrumbservice.breadcrumb]);


    }
    $(".haslist").find("div").removeClass("link-active");
    $("ul.smtreporter").find("div").removeClass("link-active");
    $("ul.smtreporter li").eq(styleindex).find("div").addClass("link-active");
    $("#testID").toggleClass("link-active");

    this.clearglobalsearchform()
  }

  Logout() {
   localStorage.clear();
   sessionStorage.clear();
    this.userService.logout().subscribe(res => {
      console.log('logout', res);
      if (res == true) {

        this.authService.logout();
      } else {
        alert('Something went wrong!!!');

        this.authService.logout();
      }

    });
    this.authService.logout();
  }

  // onOpenreporter() {
  //   this.apiService.cat_table = false;
  //   this.apiService.fav = true;
  //   this.apiService.wtl = false;
  //   this.apiService.rcv = false;
  // }

  openCategory(data: any) {

    let array: { id: string, name: any, type: any }[] = [{ "id": data.id, "name": data.name, "type": data.type }]
    this.componentSelection.emit(array);
  }

  site_name: string = "";
  site_id: string = "";
  auth_token: string = "";

  // login() {
  //   this.Tableauservice.login().subscribe(data => {
  //     if (data.credentials.site.contentUrl == "") {
  //       this.site_name = "Default"
  //     }
  //     else {
  //       this.site_name = data.credentials.site.contentUrl;
  //     }
  //     this.site_id = data.credentials.site.id;
  //     this.auth_token = data.credentials.token;
  //     this.apiService.site_id = data.credentials.site.id;
  //     this.apiService.auth_token = data.credentials.token;

  //   })
  // }
  mycategories: boolean = true;
  // smartreporter() {
  //   this.addtobreadcrumb('Smart Reporter', 1, 'Smart Reporter', false);
  //   this.addtobreadcrumb('Smart Reporter', 2, 'My Categories', true);
  //   this.breadcrumbservice.smartreportertab = !this.breadcrumbservice.smartreportertab;
  //   if ((this.apiService.wtlreports.length + this.apiService.workbooksList.length + this.apiService.trendingList.length + this.apiService.newreportslist.length + this.apiService.favreports.length + this.apiService.rcvreports.length) === 0) {
  //     this.apiService.getmapingFactData();
  //     this.CategoryTable();
  //   }

  //   this.breadcrumbservice.mycategoryiestab = false;
  // }

  clearglobalsearchform() {
    console.log("in clear")
    const selectedvalue = this.globalsearchform?.get('selectedOption')?.value
    this.globalsearchform?.reset()
    // alert(selectedvalue)
    this.globalsearchform?.get('selectedOption').setValue(selectedvalue)
  }
  servicerequestcreatedby: any

casesubtype:any;
  // casesubtype:40 casetype:110 department:20
  // picklist() {
  //   const picklistIDs = [40, 110, 20, 95, 98]; // Array of picklist IDs
  //   picklistIDs.forEach(picklistID => {
  //     this._standardUiService.getPicklistByID(picklistID).subscribe(data => {
  //       const picklistValues = [];
  //       for (let key in data) {
  //         if (data[key].active === true || data[key].active === '') {
  //           picklistValues.push({
  //             "id": data[key].id,
  //             "value": data[key].valueen
  //           });
  //         }
  //       }
  //       if (picklistID == 40) {
  //         this.casesubtypeVal.push(...picklistValues);
  //         console.log(this.casesubtypeVal)
  //       }
  //       else if (picklistID == 110) {
  //         this.casetypeVal.push(...picklistValues);
  //         console.log(this.casetypeVal)
  //       }
  //       else if (picklistID == 20) {
  //         this.departmentVal.push(...picklistValues);
  //         console.log(this.departmentVal)
  //       }
  //       else if (picklistID == 95) {
  //         this.servicerequest_source.push(...picklistValues);
  //         console.log(this.servicerequest_source)
  //       }
  //       else if (picklistID == 98) {
  //         this.addresstypeVal.push(...picklistValues);
  //         console.log(this.addresstypeVal)
  //       }
  //     });
  //   });
  // }

  // casesubtypeVal:any=[];
  // departmentVal:any=[]
  // casetypeVal: any=[];
  // servicerequest_source :any=[]
  // addresstypeVal:any=[]

  logintableauadmin() {
    // alert("in login tableau")
    this.Tableauservice.login().subscribe(data => {
      console.log(data)
      if (data.credentials.site.contentUrl == "") {
        this.site_name = "Default"
      }
      else {
        this.site_name = data.credentials.site.contentUrl;
      }
      this.site_id = data.credentials.site.id;
      this.auth_token = data.credentials.token;
      this.Tableauservice.site_id = data.credentials.site.id;
      this.Tableauservice.auth_token = data.credentials.token;

    })
  }

  ngOnInit() {




    // this.logintableauadmin()
    // this.picklist();
    // $('#dropdown_click_close').trigger('click')
    // this.globalsearchform = this.formBuilder.group({
    //   selectedOption: ['contactSearchForm'],
    //   contactSearchForm: this.formBuilder.group({
    //     lastname: ['', Validators.required],
    //     firstname: ['', Validators.required],
    //     phonenumber: ['', Validators.required],
    //     email: ['', Validators.email],
    //   }),

    //   answerSearchForm: this.formBuilder.group({
    //     summary: ['', Validators.required],
    //     phrase: ['', Validators.required],
    //     associatedarea: ['', Validators.required],
    //     answerId: ['', Validators.required],
    //   }),

    //   incidentSearchForm: this.formBuilder.group({
    //     refno: ['', Validators.required],
    //     createdby: ['', Validators.required],
    //     department: ['', Validators.required],
    //     casetype: ['', Validators.required],
    //     casesubtype: ['', Validators.required],
    //     addresstype: ['', Validators.required],
    //     addressline1: ['', Validators.required],
    //     addressline2: [''],
    //     customerfirstname: ['', Validators.required],
    //     customerlastname: ['', Validators.required],
    //     createdstart: ['', Validators.required],
    //     createdend: ['', Validators.required],
    //     servicerequestsource: ['', Validators.required],
    //   })
    // })





    // this.apiService.getmapingFactData();
    this._standardUiService.castuserDetails.subscribe((data)=>{
      if(data && data.roles[0].authority != 'Department' && data.location.locationname != data.roles[0].authority){
        setInterval(() => {

          // console.log(localStorage.getItem("onEventEstablishedInbound"))
          if (localStorage.getItem("onEventEstablishedInbound") != 'undefined' && localStorage.getItem("onEventEstablishedInbound") != null) {
            let gensys: any = JSON.parse(localStorage.getItem("onEventEstablishedInbound"))
            let payload = {
              "firstname": gensys.name,
              "phonenumber": gensys.ANI
            };
            console.log(payload);
            this.oncomponentSelection({ id: 'configuredNewSR', name: 'NewSR', type: 'configuredNewSR', src: '../../assets/images/NewSRactive.svg', geneSysData: payload })
            localStorage.removeItem('onEventEstablishedInbound');

            ;
          }
        }, 5000)
      }
    })
    // oncomponentSelection(data: any) {
    //   // Your existing logic...
    //   this.dataSharingService.sendComponentSelection(data);
    // }
    // this.getIncidentref();

  }
  // getPergeCache(){
  //   this.userService.getPergeCache().subscribe((data) => {
  //     console.log(data);
  //     if(!data){
  //       alert("Something Went Wrong")
  //     }
  //   })
  // }

  // oncomponentSelection1(data: any) {
  //   // Your existing logic...
  //   this.apiservices.sendComponentSelection(data);
  // }
  tabid: any;
  getIncidentref(componentData: any) {
    this.apiservices.gensysdata = '';
    return this.httpClient.get(this.backendUrl + 'incidentRef', { responseType: 'text' }).subscribe((data: string) => {
      this.tabid = data;
      componentData["tabid"] = data;
      this.tabsComponent.openTab(`${data}`, this.componentSelectionTemplate, componentData, true, [...this.breadcrumbservice.breadcrumb]);

    });
    // return this.httpClient.get(this.backendUrl+'/incidentRef', httpOptions).pipe(retry(2), catchError(this.handleError));

  }
  // mycategoryiestab:boolean=true;
  // stylingtab:boolean=false;
  // CategoryTable() {
  //   if (this.breadcrumbservice.stylingtab) {
  //     setTimeout(() => {
  //       ($('#data_tabletoggle') as any).dataTable(
  //         {
  //           pagingType: 'full_numbers',
  //           pageLength: 10,
  //           lengthMenu: [10, 20, 30, 40, 50, 60],
  //           processing: true,
  //           searching: true,
  //           searchHighlight: true,
  //           "bDestroy": true,
  //           drawCallback: function (settings) {
  //             const api = this.api();
  //             const rows = api.rows({ page: 'current' }).nodes();
  //             let startIndex = api.page() * api.page.len() + 1;

  //             $(rows).each(function (index) {
  //               $('td', this).eq(0).html(startIndex.toString()); // Convert to string before setting as HTML content
  //               startIndex++;
  //             });
  //           },
  //         }
  //       );
  //     })
  //     this.breadcrumbservice.stylingtab = false;
  //   }
  //   this.breadcrumbservice.breadcrumb = [];
  //   this.addtobreadcrumb('home', 0, 'Home', true);
  //   this.addtobreadcrumb('Smart Reporter', 1, 'Smart Reporter', false);
  //   this.addtobreadcrumb('Smart Reporter', 2, 'My Categories', true);
  //   // this.breadcrumbservice.smartreportertab=!this.breadcrumbservice.smartreportertab;
  //   // this.breadcrumbservice.smartreportertab=false;

  //   if ((this.apiService.wtlreports.length + this.apiService.workbooksList.length + this.apiService.trendingList.length + this.apiService.newreportslist.length + this.apiService.favreports.length + this.apiService.rcvreports.length) === 0) {
  //     this.apiService.getmapingFactData();
  //     // this.CategoryTable();
  //   }

  //   if (this.breadcrumbservice.mycategoryiestab) {
  //     if (this.breadcrumbservice.smartreportertab) {
  //       this.apiService.gettrendingreports();
  //       this.apiService.getnewreports();
  //       // this.login();
  //       this.breadcrumbservice.smartreportertab = false;
  //     }


  //     // this.breadcrumbservice.smartreportertab=false;
  //   }
  //   this.apiService.cat_table = true;
  //   this.apiService.fav = false;
  //   this.apiService.wtl = false;
  //   this.apiService.rcv = false;
  //   this.oncomponentSelection({ id: 'sm-smartreporter', name: 'Smart Reporter', type: 'sm-smartreporter' })
  //   this.breadcrumbservice.mycategoryiestab = false;
  //   // if(this.breadcrumbservice.categorytab)
  //   // {
  //   //   this.breadcrumbservice.categorytab=false;
  //   //   this.oncomponentSelection({id: 'sm-smartreporter', name: 'Smart Reporter',type:'sm-smartreporter'})
  //   // }

  // }
  // RecentlyViewdOpen() {
  //   this.breadcrumbservice.breadcrumb = [];
  //   this.addtobreadcrumb('home', 0, 'Home', true);
  //   this.addtobreadcrumb('Smart Reporter', 1, 'Smart Reporter', false);
  //   this.addtobreadcrumb('Smart Reporter', 2, 'Recently Viewed', true);
  //   // this.mycategories=true;
  //   if (this.breadcrumbservice.smartreportertab) {
  //     this.apiService.gettrendingreports();
  //     this.apiService.getnewreports();
  //     // this.login();
  //     this.breadcrumbservice.smartreportertab = false;
  //   }
  //   // this.apiService.gettrendingreports();
  //   // this.apiService.getnewreports();
  //   this.apiService.cat_table = false;
  //   this.apiService.fav = false;
  //   this.apiService.wtl = false;
  //   this.apiService.rcv = true;
  //   this.oncomponentSelection({ id: 'sm-smartreporter', name: 'Smart Reporter', type: 'sm-smartreporter' })

  //   // if(this.breadcrumbservice.categorytab)
  //   // {
  //   //   this.breadcrumbservice.categorytab=false;
  //   //   this.oncomponentSelection({id: 'sm-smartreporter', name: 'Smart Reporter',type:'sm-smartreporter'})
  //   // }
  // }

  // WatchLaterOpen() {
  //   this.breadcrumbservice.breadcrumb = [];
  //   this.addtobreadcrumb('home', 0, 'Home', true);
  //   // this.mycategories=true;
  //   this.addtobreadcrumb('Smart Reporter', 1, 'Smart Reporter', false);
  //   this.addtobreadcrumb('Smart Reporter', 2, 'View Later', true);
  //   if (this.breadcrumbservice.smartreportertab) {
  //     this.apiService.gettrendingreports();
  //     this.apiService.getnewreports();
  //     // this.login();
  //     this.breadcrumbservice.smartreportertab = false;
  //   }
  //   // this.apiService.gettrendingreports();
  //   // this.apiService.getnewreports();
  //   this.apiService.cat_table = false;
  //   this.apiService.fav = false;
  //   this.apiService.wtl = true;
  //   this.apiService.rcv = false;
  //   this.oncomponentSelection({ id: 'sm-smartreporter', name: 'Smart Reporter', type: 'sm-smartreporter' })

  //   // if(this.breadcrumbservice.categorytab)
  //   // {
  //   //   this.breadcrumbservice.categorytab=false;
  //   //   this.oncomponentSelection({id: 'sm-smartreporter', name: 'Smart Reporter',type:'sm-smartreporter'})
  //   // }
  // }



  // MyFavoritesOpen() {
  //   this.breadcrumbservice.breadcrumb = [];
  //   this.addtobreadcrumb('home', 0, 'Home', true);
  //   // this.mycategories=true;
  //   this.addtobreadcrumb('Smart Reporter', 1, 'Smart Reporter', false);
  //   this.addtobreadcrumb('Smart Reporter', 2, 'My Favourites', true);
  //   if (this.breadcrumbservice.smartreportertab) {
  //     this.apiService.gettrendingreports();
  //     this.apiService.getnewreports();
  //     // this.login();
  //     this.breadcrumbservice.smartreportertab = false;
  //   }
  //   this.apiService.cat_table = false;
  //   this.apiService.fav = true;
  //   this.apiService.wtl = false;
  //   this.apiService.rcv = false;
  //   this.oncomponentSelection({ id: 'sm-smartreporter', name: 'Smart Reporter', type: 'sm-smartreporter' })
  //   // this.apiService.gettrendingreports();
  //   // this.apiService.getnewreports();
  //   // if(this.breadcrumbservice.categorytab)
  //   // {
  //   //   this.breadcrumbservice.categorytab=false;
  //   //   this.oncomponentSelection({id: 'sm-smartreporter', name: 'Smart Reporter',type:'sm-smartreporter'})
  //   // }
  // }
}
